import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/locationgcc/dubai_new/expand.webp";
import { Link } from "gatsby";

function Expandgrowthdubai() {
  return (
    <section
      className="expand_growth_dubai"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Expand Your Business Reach with Growth-Enabling App Development
              Company in Dubai
            </h2>
            <p>
              91% of UAE organizations use custom mobile applications to
              interact with users, and 84% believe a mobile app is essential for
              businesses for experience-driven digital interactions. It’s high
              time to onboard a top-notch{" "}
              <Link to="/mobile-app-development-company-dubai">
                mobile app development company
              </Link>{" "}
              in Dubai and launch bespoke mobile solutions for better brand
              expansion and profitability.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Consult with Experts
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Expandgrowthdubai;
